// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs__kP79x"};